export default "__VITE_ASSET__Cfhg4vyo__"